import React from 'react';

import {PrescriptionTable} from '@optimaxdev/design-system';
import {Icon, Approve} from '@optimaxdev/icons';
import classNames from 'classnames';

import {PRESCRIPTION_METHOD} from 'constants/product';
import {PrescriptionType} from 'desktop/types/checkoutItemsType';
import {getPreparedCLPrescription} from 'desktop/utils/getPreparedCLPrescription/getPreparedCLPrescription';

import {SendPrescriptionLater} from '../sendPrescriptionLater/sendPrescriptionLater';

import s from './prescriptionDetails.scss';

type PropsType = {
    prescription?: PrescriptionType;
    forLenses?: boolean;
    prescriptionType?: number;
};

const defaultOculusProps = {
    add: 'None',
    axi: 'None',
    cyl: 'None',
    sph: '',
};

/**
 * Prescription Details for checkout page
 *
 * @constructor
 */
export const PrescriptionDetails: React.FC<PropsType> = ({
    forLenses = false,
    prescription,
    prescriptionType,
}) => {
    if (!prescription) return null;
    const {pd, strength} = prescription;

    const preparedOd = getPreparedCLPrescription(prescription, prescriptionType, 'od');
    const preparedOs = getPreparedCLPrescription(prescription, prescriptionType, 'os');

    switch (prescription.method) {
        case PRESCRIPTION_METHOD.FILL_IT_ONLINE_METHOD:
            return (
                <>
                    <p className={s.row}>
                        <strong className={s.title}>Prescription Details:</strong>
                    </p>
                    <div className="fs-exclude">
                        <PrescriptionTable
                            isContactLenses={forLenses}
                            od={preparedOd}
                            os={preparedOs}
                            pd={pd}
                            sizeDesktop="small"
                            variant="gray"
                            isShiftedTitles
                            shortTitles
                        />
                    </div>
                </>
            );
        case PRESCRIPTION_METHOD.MAGNIFICATION_METHOD:
            return (
                <>
                    <p className={s.row}>
                        <strong className={s.title}>Prescription Details:</strong>
                    </p>
                    <div className="fs-exclude">
                        <PrescriptionTable
                            isContactLenses={forLenses}
                            od={{...defaultOculusProps, sph: strength}}
                            os={{...defaultOculusProps, sph: strength}}
                            pd={pd}
                            sizeDesktop="small"
                            variant="gray"
                        />
                    </div>
                </>
            );
        case PRESCRIPTION_METHOD.UPLOAD_METHOD:
            return (
                <p className={classNames(s.row, s.smallMargin)}>
                    <strong className={s.title}>Prescription Details:</strong>{' '}
                    <span className={s.file}>
                        {(prescription.link || '').split('/').pop()}{' '}
                        <div className={s.iconWrap}>
                            <Icon className={s.icon} icon={Approve} />
                        </div>
                    </span>
                </p>
            );
        case PRESCRIPTION_METHOD.SEND_EMAIL_OR_FAX_METHOD:
            return <SendPrescriptionLater />;
        default:
            return null;
    }
};
